import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";


const QuoteForm = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "phone" && value.trim()) {
      if (!validatePhoneNumber(value)) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          phone: "Please enter a valid Canadian phone number.",
        }));
      } else {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          phone: "",
        }));
      }
    }

    if (name === "email" && value.trim()) {
      if (!validateEmail(value)) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          email: "Please enter a valid email address.",
        }));
      } else {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          email: "",
        }));
      }
    }
  };

  const validatePhoneNumber = (phone) => {
    const phonePattern =
      /^(\+1|1)?\s?(\(\d{3}\)|\d{3})[\s\-]?\d{3}[\s\-]?\d{4}$/;
    return phonePattern.test(phone);
  };

  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end', 
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, phone, email, subject, message } = formData;
  
    if (!name || !phone || !email || !subject || !message) {
      Toast.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "All fields are required!",
      });
      return;
    }
  
    if (!validatePhoneNumber(phone)) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        phone: "Please enter a valid Canadian phone number.",
      }));
      Toast.fire({
        icon: "error",
        title: "Invalid Phone",
        text: "Please enter a valid Canadian phone number.",
      });
      return;
    }
  
    if (!validateEmail(email)) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        email: "Please enter a valid email address.",
      }));
      Toast.fire({
        icon: "error",
        title: "Invalid Email",
        text: "Please enter a valid email address.", 
      });
      return;
    }
  
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        Toast.fire({
          icon: 'success',
          title: 'Quote request sent successfully',
        });
      
        setFormData({
          name: "",
          phone: "",
          email: "",
          subject: "",
          message: "",
        });
        setFormErrors({});
      })
      
      .catch(() => {
        Toast.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while sending your request. Try again!",
        });
      });
  };
  
  
  return (
    <div className="container" data-sal='slide-left' data-sal-duration="2000" data-sal-delay="300">
      {/* <ToastContainer position="top-center" autoClose={4000} /> */}
      <div className="row">
        <div className="col-12 col-md-8" style={{ padding: "20px", backgroundColor: "#d8b163" }}>
          <h4 className="text-white mb-3" style={{ fontFamily: "Barlow Condensed" }}>
            Request A Free Quote
          </h4>
          <form ref={formRef} onSubmit={handleSubmit}>
            
            <input
              type="text"
              name="name"
              value={formData.name}
              placeholder="Your Name"
              className="form-control mb-2"
              required
              onChange={handleChange}
            />
            {formErrors.name && <small className="text-danger">{formErrors.name}</small>}

            <input
              type="tel"
              name="phone"
              value={formData.phone}
              placeholder="Your Phone Number"
              className="form-control mb-2"
              required
              onChange={handleChange}
            />
            {formErrors.phone && <small className="text-danger">{formErrors.phone}</small>}

            <input
              type="email"
              name="email"
              value={formData.email}
              placeholder="Your Email"
              className="form-control mb-2"
              required
              onChange={handleChange}
            />
            {formErrors.email && <small className="text-danger">{formErrors.email}</small>}

            <select
              name="subject"
              value={formData.subject}
              className="form-select mb-3"
              required
              onChange={handleChange}
            >
              <option value="">Select Service</option>
              <option value="Kitchen Renovations">Kitchen Renovations</option>
              <option value="Bathroom Renovations">Bathroom Renovations</option>
              <option value="Basement Renovations">Basement Renovations</option>
              <option value="Home Extensions">Home Extensions</option>
            </select>
            {formErrors.subject && <small className="text-danger">{formErrors.subject}</small>}

            <textarea
              name="message"
              value={formData.message}
              placeholder="Additional Details or questions"
              className="form-control mb-3"
              rows="4"
              required
              onChange={handleChange}
            />
            {formErrors.message && <small className="text-danger">{formErrors.message}</small>}

            <button
              type="submit"
              className="btn btn-dark w-100 fw-semibold p-2"
              style={{ fontFamily: "Barlow Condensed" }}
            >
              REQUEST A FREE QUOTE
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default QuoteForm;
